import styles from "../styles/Home.module.css";
import InfoAndSlideShow from "../components/Sections/InfoAndSlideShow";
import ProjectsDiv from "../components/Sections/DemoProjects";
import DemoGallery from "../components/Sections/DemoGallery";
import PaymentPlans from "../components/Sections/PaymentPlans";
import Location from "../components/Sections/Location";
import { Helmet } from "react-helmet";

export default function Home() {
    return (
        <div>
            <Helmet>
                <title>Sultana Homes</title>
            </Helmet>
            <div className={styles.banner}>
                <div className="font-poppins text-3xl text-primary-white font-extralight pt-12">Welcome to</div>
                <div className="font-poppins text-primary-gold font-extralight pt-5 text-7xl text-center" style={{textShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)'}}>Sultana Homes</div>
                <div className="font-poppins text-2xl text-primary-white font-normal pt-5">Luxury Within Reach</div>
            </div>
            <InfoAndSlideShow section={1}/>
            <ProjectsDiv />
            <DemoGallery />
            <PaymentPlans background={"dark"}/>
            <Location />
            <InfoAndSlideShow section={2}/>
        </div>
    );
}
